import React from 'react';
import { VisualLab } from '../visual-lab/VisualLab';

export function VisualLabPage() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <VisualLab initialMode="idle" initialQuality="high" />
    </div>
  );
}